import React, { useState } from "react";
import "../Table/Table.css";
import toast, { Toaster } from 'react-hot-toast';
import Loading from "../Loading";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { Box, Button, Typography, TextField, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchRoles, addRole, deleteRole } from "../../api/roleApi";
import RolePermissionsTable from "./RolePermissionsTable";
import DataTableSecond from "../DataTable/DataTableSecond";
import { getPermissionByPrefix } from "../../utils/permissions";
import zIndex from "@mui/material/styles/zIndex";
import { useErrorToast } from "../../hooks/useErrorToast";

function Role() {
  const navigate = useNavigate();
    const showError = useErrorToast();
  const queryClient = useQueryClient();
const [showPermissionTable, setShowPermissionTable] = useState(false);

  const [selectedRole, setSelectedRole] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [addModal, setAddModal] = useState(false);

      const { is_view, is_add, is_edit, is_delete } = getPermissionByPrefix("manage_roles");
  

  const {
    data: roles = [],
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["roles"],
    queryFn: fetchRoles,
    onError: (error) => {
      if (error.response?.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(error.response?.data?.error || "Something went wrong");
      }
    },
  });

  const addMutation = useMutation({
    mutationFn: addRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["roles"] });
      setAddModal(false);
      setSelectedRole({});
    },
    onError: (error) => {
      handleAuthError(error);
    },
  });

  const deleteMutation = useMutation({
    mutationFn: deleteRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["roles"] });
      setDeleteModal(false);
      setSelectedRole({});
    },
    onError: (error) => {
      handleAuthError(error);
    },
  });

  const handleAuthError = (error) => {
    if (error.response?.status === 401) {
      showError("Session Expired! Please Login");
      localStorage.removeItem("tokenInv");
      localStorage.removeItem("roleInv");
      navigate("/");
    } else {
      showError(error?.response?.data?.error || "Something went wrong. Please try again.");
      // toast.error(error.response?.data?.error || "Something Went Wrong");
    }
  };

  const handleAddRole = () => {
    if (!selectedRole?.name) {
      toast.error("Please fill role name");
      return;
    }
    addMutation.mutate(selectedRole);
  };

  const handleDeleteRole = () => {
    deleteMutation.mutate(selectedRole.id);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 150 },
    { field: "name", headerName: "Name", width: 150 },
{
  field: "actions",
  headerName: "",
  width: 350,
  renderCell: (params) => (
    <Box sx={{ display: "flex", gap: "10px" }}>
    
  
     {is_edit && (   <Button
                  variant="contained"
                  onClick={() => {
          setSelectedRole(params.row);
          setShowPermissionTable(true); 
        }}
        sx={{
          fontSize: "12px",
          marginTop: "7px",
          backgroundColor: "rgb(124, 46, 160)",
        }}
                >
                   Permission
                </Button>)}
                  {is_delete && (   <> {!params?.row?.systyem && (
                  <Button
        variant="contained"
        onClick={() => {
          setSelectedRole(params.row);
          setDeleteModal(true);
        }}
        sx={{
          fontSize: "12px",
          marginTop: "7px",
          backgroundColor: "rgb(124, 46, 160)",
        }}
      >
        <FaTrash color="#FFF" size={20} title="Delete" />
      </Button>)}</>)}
    </Box>
  ),
}

  ];

  const permissionRows = [
  { id: 1, name: "Dashboard" },
  { id: 2, name: "Users" },
  { id: 3, name: "Reports" },
  { id: 4, name: "Settings" },
];

const permissionColumns = [
  { field: "name", headerName: "Name", width: 200 },
  {
    field: "view",
    headerName: "View",
    width: 100,
    renderCell: () => <input type="checkbox" />,
  },
  {
    field: "add",
    headerName: "Add",
    width: 100,
    renderCell: () => <input type="checkbox" />,
  },
  {
    field: "edit",
    headerName: "Edit",
    width: 100,
    renderCell: () => <input type="checkbox" />,
  },
  {
    field: "delete",
    headerName: "Delete",
    width: 100,
    renderCell: () => <input type="checkbox" />,
  },
];

      if (!is_view) {
  return <div>You do not have permission to view this page.</div>;
}

  return (
    <div style={profileStyle}>
<Toaster position="top-right" reverseOrder={false} style={{zIndex:999999}}/>
      {(isLoading || isFetching || addMutation.isLoading || deleteMutation.isLoading) && <Loading />}


{showPermissionTable ? (
  <div>
    <RolePermissionsTable
    selectedRole={selectedRole}
      roleId={selectedRole.id}
      onBack={() => setShowPermissionTable(false)}
    />
  </div>
) : (
  <>
    <div className="table-header">
      <h2>Role</h2>
      {is_add && ( <button className="upload-button" onClick={() => setAddModal(true)}>
        <FaPlus style={{ marginRight: "5px" }} />
        Add Role
      </button>)}
    </div>
    <div style={{ marginBottom: "30px" }}>
      <DataTableSecond columns={columns} rows={roles} />
    </div>
  </>
)}



      {/* Add Modal */}
      <Modal open={addModal} onClose={() => { setAddModal(false); setSelectedRole({}); }}>
        <Box sx={modalStyle}>
          <Typography variant="h6" sx={modalHeading}>Add Role</Typography>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            required
            name="name"
            value={selectedRole?.name || ""}
            onChange={(e) => setSelectedRole((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
          />
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Button onClick={handleAddRole} style={buttonStyle}>Submit</Button>
            <Button onClick={() => { setAddModal(false); setSelectedRole({}); }} style={buttonStyle}>Cancel</Button>
          </div>
        </Box>
      </Modal>

      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={() => { setDeleteModal(false); setSelectedRole({}); }}>
        <Box sx={modalStyle}>
          <Typography variant="h6" sx={modalHeading}>
            Are you sure you want to delete Role <b>{selectedRole?.name}</b>?
          </Typography>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Button onClick={handleDeleteRole} style={buttonStyle}>Submit</Button>
            <Button onClick={() => { setDeleteModal(false); setSelectedRole({}); }} style={buttonStyle}>Cancel</Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

const profileStyle = {
  // width: "90%",
  background: "#fff",
  borderRadius: "8px",
  marginInline: "16px",
  marginTop: "20px",
  padding: "20px",
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  width: 400,
  borderRadius: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2,
};
const modalHeading = {
  fontSize: "24px",
  marginBottom: "15px",
  marginTop: "10px",
  textAlign: "center",
};
const buttonStyle = {
  flex: 1,
  marginRight: "10px",
  fontSize: "18px",
  background: "#7C2EA0",
  color: "white",
  padding: "12px",
};

export default Role;
